<ng-container *appLet="stations$ | async as stations">
  <span class="station-name {{ stationClasses }}" *ngIf="stations">
    {{ stationCode | stationName: stations }}
  </span>
  <span class="{{ codeClasses }}" *ngIf="includeCode">
    {{ getMacOverride(stationCode) }}</span
  >
</ng-container>
